var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoLangue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 16.3125H61.625",
    strokeWidth: 5.4375,
    strokeLinecap: "round",
    stroke: "#5754E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.375 19.9375C53.739 24.2875 52.4671 37.3375 18.125 63.4375",
    strokeWidth: 5.4375,
    strokeLinecap: "round",
    stroke: "#5754E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 27.1875C23.9103 33.0587 29.3156 42.4092 43.5 56.1875",
    strokeWidth: 5.4375,
    strokeLinecap: "round",
    stroke: "#5754E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.125 77.9375L60.7002 41.6875L76.125 77.9375",
    strokeWidth: 5.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#5754E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.25 7.25L36.25 14.5",
    strokeWidth: 5.4375,
    strokeLinecap: "round",
    stroke: "#5754E5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5 70.6875C69.4792 71.2917 63.4375 72.0143 58 68.875",
    strokeWidth: 5.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#5754E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLangue);
export default __webpack_public_path__ + "static/media/logoLangue.9d901a0024a8e9a2c383e173cd0722c2.svg";
export { ForwardRef as ReactComponent };